<!-- =========================================================================================
  File Name: ItemGridView.vue
  Description: Item Component - Grid VIew
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
            <vx-card class="mb-base" v-on="$listeners" >
                <template slot="no-body">

                    <!-- ITEM IMAGE -->
                    <div class="flex" >
                    <router-link :to="{ path: '/folder' +'/'+ item.id}" class="text-inherit " >
                    <div class="cursor-pointer" >
                        <vs-tooltip :text="item.name">
                        <img src="@/assets/images/pages/folder.svg" :alt="item.name" width="60px" class="grid-view-img">
                        </vs-tooltip>
                    </div>
                    </router-link >
                        <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
                            <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-4 h-4 hover:text-primary stroke-current"/>
                            <vs-dropdown-menu>
                            <vs-dropdown-item @click="ChangeName(item)">
                            <span class="flex items-center"  >
                                <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                                <span>Rename</span>
                            </span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="deleteFolder(item.id)">
                            <span class="flex items-center"  >
                                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                                <span>Delete</span>
                            </span>
                            </vs-dropdown-item>

     

                            </vs-dropdown-menu>
                            </vs-dropdown>
                      
                    </div>
                    <!-- <p style="font-variant: small-caps; font-size: 12px;text-align: left">{{item.name}}</p> -->


                    <!-- <div class="item-details px-4">
                        <div class="my-4 flex justify-between flex-wrap"  >
                            <small class="truncate font-semibold mb-1 hover:text-primary cursor-pointer text-center" >{{ item.name }}</small>
                             <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
                                <div>
                                <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-4 h-4 hover:text-primary stroke-current"/>
                                </div>
                            <vs-dropdown-menu>
                            <vs-dropdown-item>
                            <span class="flex items-center" @click="ChangeName(item)" >
                                <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                                <span>Rename</span>
                            </span>
                            </vs-dropdown-item>
                            <vs-dropdown-item>
                            <span class="flex items-center" @click="deleteFolder(item.id)" >
                                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                                <span>Delete</span>
                            </span>
                            </vs-dropdown-item>

     

                            </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                    </div> -->
                    <!-- SLOT: ACTION BUTTONS -->
                </template>
            <template slot="no-body">   
            <vs-popup class="holamundo" title="Rename" :active.sync="RenamePopupActive">
                <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10" >
                    <vs-input v-model="oldfolder.newname" class="w-full"></vs-input>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" >
                   <vs-button @click.native="RenameFolder(oldfolder)">Save</vs-button>
                </vs-col>
               </vs-row>
            </vs-popup>
            </template>
            </vx-card>
</template>

<script>

import {
CHANGE_FOLDER_NAME,
DELETE_IMG_LIBRARY_FOLDER
} from '@/graphql'
export default{
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    RenamePopupActive:false,
    oldfolder:{}
    }
  },
//   watch: { 

//       '$route' (to, from) {
         
//         if(to !== from ) {
// alert("change")
//         }
//       }
// },
  methods: {
    gotoFolder(id){
        //  window.location = '/folder' +'/'+ id
      this.$router.push({ path: '/folder' +'/'+ id}).catch(()=>{}); 
    },
    deleteFolder(id){
      this.$apollo
        .mutate({
          mutation: DELETE_IMG_LIBRARY_FOLDER,
          variables: {
                id: id,
          }
        })
        .then(response => {
            console.log(response)
            if(response.data.deleteImgLibraryFolder.status==='Success'){
                 this.$emit('getdata','folder')
            }
            else{
                this.$vs.notify({
                  title: 'Images',
                  text:  response.data.deleteImgLibraryFolder.message,
                  color: 'danger',
                  position: 'top-right'
                })
            }
        }
        )
    },
    ChangeName(folder){
     this.oldfolder=folder
     this.oldfolder.newname=folder.name
     this.RenamePopupActive=true
    },
    RenameFolder(folder){
    if(folder.id){
        this.RenamePopupActive=false
        this.oldfolder.name=folder.newname
         this.$apollo
        .mutate({
          mutation: CHANGE_FOLDER_NAME,
          variables: {
                name: folder.newname,
                id: folder.id,
          }
        })
        .then(response => {
             this.oldfolder={}
              this.$emit('getdata','folder')
        }
        )
    }
    },


  },
}
</script>

<style lang="scss" scoped>
.grid-view-item {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
